<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M3 6l6-3 6 3 6-3v12l-6 3-6-3-6 3z" />
    </svg>
</template>
